<script>
    export let isMobile;

    let readingMore = false;

    function handleReadMore() {
        readingMore = true;
    }
</script>

<div class="bio">
    {#if !isMobile}
        <div class="social-links">
            <a href="https://github.com/armollica">
                <i class="fab fa-github-square"></i>
            </a>
            <a href="https://twitter.com/armollica">
                <i class="fab fa-twitter-square"></i>
            </a>
        </div>
    {/if}
    <h1>Andrew Mollica</h1>
    <p>
        Graphics reporter at the <a href="https://www.wsj.com/">Wall Street Journal</a>.
        {#if !readingMore}
            <span class="read-more" on:click={handleReadMore}>Read more...</span>
        {/if}
    </p>
    
    
    {#if readingMore}
        <p>
            I studied economics and Russian at the University of 
            <span class="no-wrap">Wisconsin–Madison</span>, 
            eventually getting my master's in applied economics.
        </p>
        <p>
            Before working in journalism, I was as an economist at the 
            <a href="https://www.bls.gov/">Bureau of Labor Statistics</a>. 
            I helped forecast the numbers behind the 
            <a href="https://www.bls.gov/ooh/">Occupational Outlook Handbook</a>.
        </p>
        <p>
            I worked at the <a href="https://www.jsonline.com/">Milwaukee Journal Sentinel</a>
            for a number of years. I designed and developed data-driven, graphics-led 
            stories and built custom web pages for special projects and investigations.
        </p>
    {/if}
    
    <p>Below are some project I've worked on.</p>

    {#if isMobile}
        <div class="social-links social-links--mobile">
            <a href="https://github.com/armollica">
                <i class="fab fa-github-square"></i>
            </a>
            <a href="https://twitter.com/armollica">
                <i class="fab fa-twitter-square"></i>
            </a>
        </div>
    {/if}
</div>

<style>
    .bio {
        padding: 0px 0.5em;
    }

    .social-links {
        float: right;
    }

    .social-links a {
        color: inherit;
    }

    .social-links.social-links--mobile {
        float: none;
        text-align: right;
        font-size: 1.75em;
    }

    .social-links.social-links--mobile i {
        padding: 0px 0.1em;
    }

    .read-more {
        font-style: italic;
        color: #999;
        padding: 0px 0.25em;
        font-size: 75%;
        cursor: pointer;
    }
</style>
